<!--选择部门，角色，人员-->
<style lang="less">
    @media screen and (min-width:1900px) {
        .dep-role-person-wrap .ivu-modal{ width: 300mm !important;}
        /*.targetImplement .target_title{ width: 700px; }*/
    }
    @media screen and (min-width:1500px) and (max-width:1899px) {
        .dep-role-person-wrap .ivu-modal{ width: 300mm !important;}
    }
    @media screen and (max-width:1499px) {
        .dep-role-person-wrap .ivu-modal{ width: 295mm !important;}
    }
    @media screen and (max-width:1366px) {
        .dep-role-person-wrap .ivu-modal{top:50px}
    }
    .dep-role-person-wrap {
        .ivu-modal-body {
            padding: 0;
        }
        .select-body{
            display: flex;
            .part-list {
                position: relative;
                border-right: 1px ;
                flex: 1;
                border-right: 1px solid #dce1e8;
                height: 500px;
                overflow: auto;
                .part-title {
                    padding: 10px;
                    color:#1D1D1D;
                    font-size: 14px;
                }
            }
            .selector-treelist {
                .treelist-content {
                    .tree-item {
                        height: 46px;
                        padding: 0 15px;
                        display: flex;
                        align-items: center;
                        cursor: pointer;
                        .tree-item-title {
                            flex: 1;
                            padding: 5px 0;
                            white-space: nowrap;
                            text-overflow: ellipsis;
                        }
                        .children-tree-btn {
                            margin-left: auto;
                            cursor: pointer;
                            color: #2d8cf0;
                            padding-right: 15px;
                        }
                    }
                    .tree-item:hover{
                        background-color: #f0f1f7;
                    }
                    .selected-icon {
                        color:#09BB07
                    }
                }
            }
            .part-department{

            }
            .part-role {
                flex: 0.8;
            }
            .part-user {
                flex: 0.8;
            }
            .selector-right-list {
                border-right:none;
            }
        }
    }
</style>
<template>
    <div>
        <Modal v-model="visible" class="dep-role-person-wrap" title="选择部门、角色与人员"  @on-ok="ok" @on-cancel="cancel">
            <div class="select-body">
                <div class="part-list selector-treelist part-department">
                    <div class="part-title">
                        <span>部门：</span>
                    </div>
                    <div class="treelist-content">
                        <ul>
                            <li v-for="dep in departments" :key="dep.code" @click.stop="selectTreeItem(dep,'department')" >
                                <div class="tree-item">
                                    <span class="tree-item-title">
                                        <i class="iconfont " :class="{'icon-weixuanze':selectedDepartments.indexOf(dep.code)==-1,'icon-xuanze selected-icon':selectedDepartments.indexOf(dep.code)!=-1}"></i>
                                        {{dep.name}}
                                    </span>
                                    <span v-if="dep.child!=undefined && dep.child.length>0 && selectedDepartments.indexOf(dep.code)==-1" class="children-tree-btn" @click.stop="showChild(dep)">
                                        <i class="iconfont" :class="{'icon-zirenwu':dep.showChild !=true,'icon-shangla':dep.showChild==true}" ></i>
                                        <span v-if="dep.showChild !=true">下一级</span>
                                        <span v-if="dep.showChild ==true">收起</span>
                                    </span>
                                    <span class="children-tree-btn" @click.stop="getDepRoles(dep)">
                                        <i class="iconfont icon-navicon-jsgl"></i>
                                        角色
                                    </span>
                                </div>
                                <ul style="background-color: #fafafa" v-show="dep.showChild==true && selectedDepartments.indexOf(dep.code)==-1">
                                    <li v-for="subDep in dep.child" :key="subDep.code" style="padding-left: 30px" @click.stop="selectTreeItem(subDep,'department')">
                                        <div class="tree-item">
                                            <span class="tree-item-title">
                                                <i class="iconfont " :class="{'icon-weixuanze':selectedDepartments.indexOf(subDep.code)==-1,'icon-xuanze selected-icon':selectedDepartments.indexOf(subDep.code)!=-1}"></i>
                                                {{subDep.name}}
                                            </span>
                                            <span v-if="subDep.child!=undefined && subDep.child.length>0 && selectedDepartments.indexOf(subDep.code)==-1" class="children-tree-btn" @click.stop="showChild(subDep)">
                                                <i class="iconfont" :class="{'icon-zirenwu':subDep.showChild !=true,'icon-shangla':subDep.showChild==true}"></i>
                                                <span v-if="subDep.showChild !=true">下一级</span>
                                                <span v-if="subDep.showChild ==true">收起</span>
                                            </span>
                                            <span class="children-tree-btn" @click.stop="getDepRoles(subDep)">
                                                <i class="iconfont icon-navicon-jsgl"></i>
                                                角色
                                            </span>
                                        </div>
                                        <ul style="background-color: #fafafa" v-show="subDep.showChild==true && selectedDepartments.indexOf(subDep.code)==-1">
                                            <li v-for="threeDep in subDep.child" :key="threeDep .code" style="padding-left: 30px" @click.stop="selectTreeItem(threeDep,'department')">
                                                <div class="tree-item">
                                                    <span class="tree-item-title">
                                                        <i class="iconfont " :class="{'icon-weixuanze':selectedDepartments.indexOf(threeDep.code)==-1,'icon-xuanze selected-icon':selectedDepartments.indexOf(threeDep.code)!=-1}"></i>
                                                        {{threeDep.name}}
                                                    </span>
                                                    <span v-if="threeDep.child != undefined && threeDep.child.length>0 && selectedDepartments.indexOf(threeDep.code)==-1" class="children-tree-btn" @click.stop="showChild(threeDep)">
                                                        <i class="iconfont" :class="{'icon-zirenwu':threeDep.showChild !=true,'icon-shangla':threeDep.showChild==true}"></i>
                                                        <span v-if="threeDep.showChild !=true">下一级</span>
                                                        <span v-if="threeDep.showChild ==true">收起</span>
                                                    </span>
                                                    <span class="children-tree-btn" @click.stop="getDepRoles(threeDep)">
                                                        <i class="iconfont icon-navicon-jsgl"></i>
                                                        角色
                                                    </span>
                                                </div>
                                                <ul style="background-color: #fafafa" v-show="threeDep.showChild==true && selectedDepartments.indexOf(threeDep.code)==-1">
                                                    <li v-for="fourDep in threeDep.child" :key="fourDep.code" style="padding-left: 30px" @click.stop="selectTreeItem(fourDep,'department')">
                                                        <div class="tree-item">
                                                            <span class="tree-item-title">
                                                                <i class="iconfont " :class="{'icon-weixuanze':selectedDepartments.indexOf(fourDep.code)==-1,'icon-xuanze selected-icon':selectedDepartments.indexOf(fourDep.code)!=-1}"></i>
                                                                {{fourDep.name}}
                                                            </span>
                                                            <span v-if="fourDep.child != undefined && fourDep.child.length>0 && selectedDepartments.indexOf(fourDep.code)==-1" class="children-tree-btn" @click.stop="showChild(fourDep)">
                                                                <i class="iconfont" :class="{'icon-zirenwu':fourDep.showChild !=true,'icon-shangla':fourDep.showChild==true}"></i>
                                                                <span v-if="fourDep.showChild !=true">下一级</span>
                                                                <span v-if="fourDep.showChild ==true">收起</span>
                                                            </span>
                                                            <span class="children-tree-btn" @click.stop="getDepRoles(fourDep)">
                                                                <i class="iconfont icon-navicon-jsgl"></i>
                                                                角色
                                                            </span>
                                                        </div>
                                                    </li>
                                                </ul>
                                            </li>
                                        </ul>
                                    </li>
                                </ul>
                            </li>
                        </ul>
                    </div>
                </div>
                <div class="part-list selector-treelist part-role">
                   <div class="part-title">
                       <span>角色：</span>
                   </div>
                   <div class="treelist-content">
                       <ul>
                           <li v-for="role in roles" :key="role.rolename" @click.stop="selectTreeItem(role,'role')">
                           <div class="tree-item">
                               <span class="tree-item-title">
                                   <i class="iconfont" :class="{'icon-weixuanze':selectedRoles.indexOf(role.roleid)==-1,'icon-xuanze selected-icon':selectedRoles.indexOf(role.roleid)!=-1}"></i>
                                   {{role.rolename}}
                               </span>
                               <span class="children-tree-btn" @click.stop="getRolePersons(role)">
                                   <i class="iconfont icon-zirenwu"></i>
                                   人员
                               </span>
                           </div>
                           </li>
                       </ul>
                   </div>
                </div>
                <div class="part-list selector-treelist part-user">
                    <div class="part-title">
                        <span>人员：</span>
                    </div>
                    <div class="treelist-content">
                        <ul>
                            <li v-for="per in persons" :key="per.userid" @click.stop="selectTreeItem(per,'user')">
                                <div class="tree-item" disabled="display">
                                    <span class="tree-item-title">
                                        <i class="iconfont" :class="{'icon-weixuanze':selectedUsers.indexOf(per.userid)==-1,'icon-xuanze selected-icon':selectedUsers.indexOf(per.userid)!=-1}"  v-show="have_person" ></i>
                                        {{per.realname}}
                                    </span>
                                </div>
                            </li>
                        </ul>
                    </div>
                </div>
                <div class="part-list selector-treelist selector-right-list">
                   <div class="part-title">
                      <span>已选:</span>
                   </div>
                   <div class="treelist-content">
                       <ul>
                           <li class="tree-item" v-for="item in selectedPeoples" style="position: relative">
                               <span>{{item.department}}</span>&nbsp;&nbsp;<span>{{item.role}}</span>&nbsp;&nbsp;<span>{{item.username}}</span>
                               <i style="position: absolute;right: 10px;color:#e53d51;" class="iconfont icon-shanchu1" @click="removePerson(item)"></i>
                           </li>
                       </ul>
                   </div>
                </div>
            </div>
        </Modal>
    </div>
</template>
<script>
    import {deepCopy} from 'iview/src/utils/assist';
    export default {
        props:{
            selectedPersons:{
                type:Array,
                default(){
                    return []
                }
            },
            value:{
                type: Boolean,
                default: false
            },
            existPeoples:{
                type:Array,
                default(){
                    return []
                }
            }
        },
        data() {
            return {
                display:false,
                have_person:true,
                visible:this.value,
                departments: [],
                roles: [],
                persons: [],
                selectedPeoples: deepCopy(this.existPeoples),
                selectedDepartments:[],//已选部门
                selectedRoles:[],//已选角色
                selectedUsers:[],//已选人员
                currentQueryDepartment:'',
                currentQueryRole:'',
            }
        },
        mounted() {
            this.getDepartments();
        },
        methods:{
            ok(){
                this.$emit('input', false);
                this.$emit('on-ok',this.selectedPeoples);
                this.selectedPeoples = deepCopy(this.existPeoples);
            },
            cancel(){
                this.visible = false;
                this.$emit('input', false);
                this.$emit('on-cancel',false);
                this.selectedPeoples = deepCopy(this.existPeoples);
            },
            //获取部门信息
            getDepartments(){
                let that = this;
                let params = {};
//                params.url = 'sys/department/list'
                params.url = '/sys/department/searchbytree'
                params.data = {};
                params.system_id = 5000000;
                params.token = window.localStorage.getItem("token");
                params.success = function (res) {
                    res = res.data;
                    if (res.code = '0000') {
                      console.log(888);
                      console.log(res);
                      console.log(888);
                        that.departments = res.result.department_tree;
                    }
                };
                this.ajaxPost(params)
            },
            //根据部门获取角色信息
            getRoles(dep) {
                let that = this;
                this.roles = [];
                var params = {};
                params.url = '/sys/role/list'
//                params.url = 'sys/role/searchByDepartment'
                params.token = window.localStorage.getItem("token");
                params.data = {'searchValue': {'department.name': dep, 'flag': 0}};
                params.success = function (res) {
                    res = res.data;
                    if (res.code = '0000') {
                        console.log(res)
                        that.roles=res.result.result
                    }
                    console.log(that.roles);
                };
                this.ajaxPost(params)
            },
            //根据部门、角色获取人员
            getPeople:function (role) {
                console.log(role);
                var that = this;
                this.have_person=true;
                this.persons = [];
                var params = {};
                params.url = '/sys/userinfo/search';
                params.token = window.localStorage.getItem("token");
                params.data ={'rolename':role.rolename,'department_name':role.department.name};
                params.success = function (res) {
                    res = res.data;
                    console.log(res);
                    if (res.code = '0000') {
                        if(res.result.result.length==0){
                            that.persons=[{userid:'none',realname:'暂无人员'}];
                            that.have_person=false;
                            that.display=true;
                        }else{
                            that.persons=res.result.result
                        }

                    }
                };
                this.ajaxPost(params)
            },
            //获取部门对应的角色列表
            getDepRoles:function (dep) {
                this.currentQueryDepartment = dep;
                this.persons.splice(0,this.persons.length)
                this.getRoles(dep.name)
            },
            //获取角色对应的人员列表
            getRolePersons:function (role) {
                this.currentQueryRole = role;
                this.getPeople(role)
            },
            removePerson(peo){
                this.selectedPeoples.removeByValue(peo);
                if(peo.department != '' && peo.role == '' && peo.username == ''){
                    this.selectedDepartments.removeByValue(peo.dep_id)
                }else if(peo.department != '' && peo.role != '' && peo.username == ''){
                    this.selectedRoles.removeByValue(peo.roleid)
                }else if(peo.department != '' && peo.role != '' && peo.username != ''){
                    this.selectedUsers.removeByValue(peo.userid)
                }
            },

            //展开下一级部门
            showChild:function (dep) {
                this.$set(dep,'showChild',!dep.showChild);
            },
            //选择type:department,role,user;data:对应type的数据
            selectTreeItem:function (data,type) {
                let obj = {department:'',role:'',username:''};
                let selectedPer;
                switch(type){
                    case 'department':
                        obj.department = data.name;
                        this.$set(obj,'dep_id',data.code);
                      for(let i=0;i<this.selectedPeoples.length;i++){
                            selectedPer = this.selectedPeoples[i];
                            if(obj.department == selectedPer.department && obj.role == selectedPer.role && obj.username == selectedPer.username){
                                this.selectedPeoples.splice(i,1);
                                this.selectedDepartments.removeByValue(obj.dep_id);
                                return;
                            }else {
                                continue;
                            }
                        };
                        if(this.canAddToSelectePeoples(obj)){
                            this.selectedPeoples.push(obj);
                            this.selectedDepartments.push(data.code)
                        }
                        break;
                    case 'role':
                        obj.department = data.department.name;
                        obj.role = data.rolename;
                        this.$set(obj,'roleid',data.roleid);
                        for(let i=0;i<this.selectedPeoples.length;i++){
                            selectedPer = this.selectedPeoples[i];
                            if(obj.department == selectedPer.department && obj.role == selectedPer.role && obj.username == selectedPer.username){
                                this.selectedPeoples.splice(i,1);
                                this.selectedRoles.removeByValue(obj.roleid);
                                return;
                            }else {
                                continue;
                            }
                        };
                        if(this.canAddToSelectePeoples(obj)){
                            this.selectedPeoples.push(obj);
                            this.selectedRoles.push(data.roleid)
                        }
                        break;
                    case 'user':
                        obj.department = this.currentQueryDepartment.name;
                        obj.role = this.currentQueryRole.rolename;
                        obj.username=data.realname;
                        this.$set(obj,'userid',data.userid);
                        for(let i=0;i<this.selectedPeoples.length;i++){
                            selectedPer = this.selectedPeoples[i];
                            if(obj.department == selectedPer.department && obj.role == selectedPer.role && obj.username == selectedPer.username){
                                this.selectedPeoples.splice(i,1);
                                this.selectedUsers.removeByValue(obj.userid);
                                return;
                            }else {
                                continue;
                            }
                        };
                        if(this.canAddToSelectePeoples(obj)){
                            this.selectedPeoples.push(obj);
                            this.selectedUsers.push(data.userid)
                        }
                        break;
                };
                console.log(obj)
            },
            //判断是否可以添加到已选框框
            canAddToSelectePeoples:function(people){
                let flag = true;//true时可以添加
                if (people.department == "" && people.role == "" && people.name == "") {
                    return flag = false;
                };
                let selected_people;
                for (let i=0;i< this.selectedPeoples.length;i++) {
                    selected_people = this.selectedPeoples[i];
                    if (selected_people.department != '' && selected_people.role == '' && selected_people.username == '') {//已选择人人员中存在只选中某部门时，新添加的人员属于这个部门时，不让新添加该人员
                        if (people.department == selected_people.department) {
                            return flag = false;
                        }
                    } else if (selected_people.department != '' && selected_people.role != '' && selected_people.username == '') {//已选择人员中存在只选中某部门下某角色时，新添加的人员属于这个部门下的这个角色时，不让新添加该人员
                        if (people.department == selected_people.department && people.role == selected_people.role) {
                          return flag = false;
                        }
                        //新添加的人包含，已选择的人员时不让添加
                        if(people.department == selected_people.department && (people.role == '' || people.role == selected_people.role)) return flag=false;

                    } else {//已选择人员中存在和新添加的人相同时，不让新添加该人
                        if (people.department == selected_people.dep && people.role == selected_people.role && people.name == selected_people.username) {
                            return flag=false;
                        };
                        //新添加的人包含，已选择的人时不让添加
                        if(people.department == selected_people.department && (people.role == '' || people.role == selected_people.role) && people.username == ''){
                          return flag=false;
                        }
                    }
                }
                return flag;
            },
        },
        watch:{
            value(val){
                this.visible = val;
            },
            existPeoples(){
                this.selectedPeoples = deepCopy(this.existPeoples);
                this.selectedDepartments.splice(0,this.selectedDepartments.length);//已选部门
                this.selectedRoles.splice(0,this.selectedRoles.length);//已选角色
                this.selectedUsers.splice(0,this.selectedUsers.length)//已选人员
                for(let i=0;i<this.existPeoples.length;i++){
                    let peo = this.existPeoples[i];
                    if(peo.department != '' && peo.role == '' && peo.username == ''){
                        this.selectedDepartments.push(peo.dep_id)
                    }else if(peo.department != '' && peo.role != '' && peo.username == ''){
                        this.selectedRoles.push(peo.roleid)
                    }else if(peo.department != '' && peo.role != '' && peo.username != ''){
                        this.selectedUsers.push(peo.userid)
                    }
                }
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/infoMana/departmentRolePerson3.vue